import React from "react";
import Icon from "ui/Icon";
import CopyIcon from "core/icons/copy/copy-2.svg";
import { Container, CopyText, CopyButton } from "./_copyToClipboardStyle";

type Props = {
  ariaLabel?: string;
  text: string;
  onCopy?: () => void;
  disabled?: boolean;
};

function CopyToClipboard(props: Props) {
  const { text, ariaLabel = "Copy Link", disabled, onCopy, ...rest } = props;

  const onCopyHandler = () => {
    navigator.clipboard.writeText(text);
    onCopy && onCopy();
  };

  return (
    <Container {...rest}>
      <CopyText spellCheck={false} value={text} readOnly disabled={disabled} />
      <CopyButton aria-label={ariaLabel} onClick={onCopyHandler} disabled={disabled}>
        <Icon src={CopyIcon} size={16} />
      </CopyButton>
    </Container>
  );
}

CopyToClipboard.defaultProps = {
  text: "",
};

export default CopyToClipboard;
